
document.addEventListener("DOMContentLoaded", function(){

let grid = document.querySelector(".featured-coll.collection .product-grid");
if(!grid) return;

let items = Array.from(grid.children);

// shuffle
items.sort(() => 0.5 - Math.random());

// reorder
items.forEach(item => grid.appendChild(item));

// show grid after shuffle
grid.style.visibility = "visible";

});